export default __webpack_public_path__ + "static/media/phonedial.822b8cfb.mp3";